import global from './global';
import auth from './auth';
import meeting from './meeting';
import user from './user';
import notification from './notification';
import admin from './admin';
import error from './error';

const pl = {
  global,
  auth,
  meeting,
  user,
  notification,
  admin,
  error
};

export default pl;
